import React, { ReactNode } from 'react';

import { Text, IconButton } from "@primer/react";
import { Stack } from "@primer/react/experimental";
import { XIcon, InfoIcon } from '@primer/octicons-react'

interface InfoActionsBannerProps {
    title: string
    buttons: ReactNode[];
    onDismiss: () => void;
    didDismiss: () => void;
}

const InfoActionsBanner: React.FC<InfoActionsBannerProps> = ({ title, buttons, onDismiss, didDismiss }) => {

    return (
        <div className="h-[52px] bg-[#DDF4FF] border border-[#54AEFF66] rounded-md floating-toast inline-flex items-center">
            <div className='flex items-center'>
                <Stack align="center" direction="horizontal" className='ml-4 mr-2' gap={'none'}>
                    <InfoIcon className='text-[#0969DA]' />
                    <Text size="medium" className='ml-2 mr-[10px] whitespace-nowrap'>{title}</Text>
                    {buttons.map((button, index) => {
                        return <div key={index} className='ml-1 mr-1'>{button}</div>;
                    })}
                    <IconButton
                        onClick={() => {
                            onDismiss();
                            didDismiss();
                        }}
                        icon={XIcon}
                        variant="link"
                        aria-label="Закрыть"
                        className='ml-[10px]' />
                </Stack>
            </div>
        </div>
    );
};

export default InfoActionsBanner;